export const environment = {
  production: false,
  uat: false,
  staging: true,
  development: false,
  environment: 'staging',
  baseUrl: 'https://stg-mpiw-api.tracwater.online',
  portalId: '6a6026f8540dd9f5c4827b18',
  portalTypeId: '6895970418f8a8985a2aebe2'
};
